<template>
<ItpUsercontrol
  loading-spinner
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Properties'|pgettext('RentalFormProperties') }}
      </strong>
      <ItpButton
        :text="'Add property...'|gettext"
        size="sm"
        variant="light"
        class="ml-auto"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      v-if="loaded"
    >
      <BListGroupItem
        class="card-body text-center"
        v-if="!items.length"
      >
        <span>
          {{ 'No properties.'|pgettext('RentalFormProperties') }}
        </span>
      </BListGroupItem>
      <BListGroupItem
        :key="item.id"
        class="d-flex flex-column"
        v-for="item in items"
      >
        <DIV
          class="w-100"
        >
          <DIV
            class="d-flex flex-row"
          >
            <DIV
              class="px-2"
            >
              {{ item.property_unit.full_name }}
            </DIV>
            <DIV
              :id="item.property_unit.unit_type"
              class="px-2"
            >
              {{ item.property_unit.unit_type }}
            </DIV>
          </DIV>
          <DIV
            class="d-flex flex-row my-1"
          >
            <DIV
              class="px-2"
            >
              {{ item.valid_from }}
            </DIV>
            <DIV
              class="px-2"
            >
              {{ item.valid_to }}
            </DIV>
          </DIV>
          <DIV
            class="d-flex flex-row"
          >
            <ItpBadge
              variant="secondary"
              class="mx-2 shadow-none"
              v-if="item.locked"
            >
              <ItpIcon
                fa="lock"
                class="px-2"
              >
              </ItpIcon>
              <SPAN>
                {{ 'Locked'|gettext }}
              </SPAN>
            </ItpBadge>
            <ItpBadge
              :text="'Inactive'|gettext"
              variant="warning"
              class="mx-2 shadow-none"
              v-if="item.inactive"
            >
            </ItpBadge>
          </DIV>
        </DIV>
        <DIV
          class="ml-2 d-flex flex-row"
        >
          <ItpButton
            variant="default"
            size="sm"
            icon="fa-edit"
            v-if="editable"
            @click.prevent.stop="evh_6853569216922577_clickPreventStop($event, {item})"
          >
          </ItpButton>
          <ItpButton
            variant="default"
            size="sm"
            icon="fa-trash"
            v-if="editable && !item.locked"
            @click.prevent.stop="evh_6492569393195423_clickPreventStop($event, {item})"
          >
          </ItpButton>
        </DIV>
      </BListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRentalFormProperties extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Boolean,
    default: true,
  })
  editable!: boolean;

  @Watch('editable')
  onEditable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editable")
  }

  @Prop({
    required: true,
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_rental_property', { parameters: { rental_id: this.rentalId } })
  }

  ux!: any;
  dataMembers = ['items', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: {
          initialLoadSpinner: true,
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_close_9463_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9463, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_9462_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9462, alias=undefined
    return {
      name: "RentalProperty",
      props: {
        rentalId: this.rentalId,
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_6853569216922577_close_9467_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6853569216922577_close_9467, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_6853569216922577_showModal_9466_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6853569216922577_showModal_9466, alias=undefined
    return {
      name: "RentalProperty",
      props: {
        rentalId: this.rentalId,
        resourceId: $event.data.item.id,
      }
      ,
    }
  }

  async evh_6853569216922577_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6853569216922577_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6492569393195423_request_9470_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6492569393195423_request_9470, alias=undefined
    return {
      operation: "delete_rental_property",
      data: { ...$event.data.prop, rental_id: this.rentalId },
    }
  }

  async act_6492569393195423_request_9470_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6492569393195423_request_9470, alias=undefined
    return {
      message: this.$fn.gettext("Please confirm delete."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_6492569393195423_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6492569393195423_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9460: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9459: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_9464: actions.ReloadComponentDataAction;
    evh_8320016629450276_close_9463: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9462: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9461: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6853569216922577_reloadComponentData_9468: actions.ReloadComponentDataAction;
    evh_6853569216922577_close_9467: actions.EventHandlerImpl;
    act_6853569216922577_showModal_9466: actions.ShowModalAction;
    evh_6853569216922577_clickPreventStop_9465: actions.EventHandlerImpl;
    evh_6853569216922577_clickPreventStop: actions.EventHandlerGroup;
    act_6492569393195423_reloadComponentData_9472: actions.ReloadComponentDataAction;
    evh_6492569393195423_success_9471: actions.EventHandlerImpl;
    act_6492569393195423_request_9470: actions.RequestAction;
    evh_6492569393195423_clickPreventStop_9469: actions.EventHandlerImpl;
    evh_6492569393195423_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9460 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9459 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9460,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9459],
      }
    );
    const act_8320016629450276_reloadComponentData_9464 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8320016629450276_close_9463 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_9464,
        event: "close",
        when: this.evh_8320016629450276_close_9463_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_8320016629450276_showModal_9462 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9462_getActionArgs,
        events: [evh_8320016629450276_close_9463],
      }
    );
    const evh_8320016629450276_clickPreventStop_9461 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9462,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9461],
      }
    );
    const act_6853569216922577_reloadComponentData_9468 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6853569216922577_close_9467 = new actions.EventHandlerImpl(
      {
        action: act_6853569216922577_reloadComponentData_9468,
        event: "close",
        when: this.evh_6853569216922577_close_9467_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_6853569216922577_showModal_9466 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6853569216922577_showModal_9466_getActionArgs,
        events: [evh_6853569216922577_close_9467],
      }
    );
    const evh_6853569216922577_clickPreventStop_9465 = new actions.EventHandlerImpl(
      {
        action: act_6853569216922577_showModal_9466,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_6853569216922577_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6853569216922577_clickPreventStop_9465],
      }
    );
    const act_6492569393195423_reloadComponentData_9472 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6492569393195423_success_9471 = new actions.EventHandlerImpl(
      {
        action: act_6492569393195423_reloadComponentData_9472,
        event: "success",
        displayName: "reloadComponentData",
      }
    );
    const act_6492569393195423_request_9470 = new actions.RequestAction(
      {
        actionArgs: this.act_6492569393195423_request_9470_getActionArgs,
        confirm: this.act_6492569393195423_request_9470_getConfirm,
        events: [evh_6492569393195423_success_9471],
      }
    );
    const evh_6492569393195423_clickPreventStop_9469 = new actions.EventHandlerImpl(
      {
        action: act_6492569393195423_request_9470,
        event: "click.prevent.stop",
        displayName: "request",
      }
    );
    const evh_6492569393195423_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6492569393195423_clickPreventStop_9469],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9460,
      evh_7315092382398562_reload_9459,
      evh_7315092382398562_reload,
      act_8320016629450276_reloadComponentData_9464,
      evh_8320016629450276_close_9463,
      act_8320016629450276_showModal_9462,
      evh_8320016629450276_clickPreventStop_9461,
      evh_8320016629450276_clickPreventStop,
      act_6853569216922577_reloadComponentData_9468,
      evh_6853569216922577_close_9467,
      act_6853569216922577_showModal_9466,
      evh_6853569216922577_clickPreventStop_9465,
      evh_6853569216922577_clickPreventStop,
      act_6492569393195423_reloadComponentData_9472,
      evh_6492569393195423_success_9471,
      act_6492569393195423_request_9470,
      evh_6492569393195423_clickPreventStop_9469,
      evh_6492569393195423_clickPreventStop,
    }
  }
}

Vue.component("UcRentalFormProperties", UcRentalFormProperties);

</script>